import React, { useState } from "react";
import cn from "classnames";
import styles from "./Product.module.sass";
import Control from "./Control";
import Icon from "../Icon";
import Checkbox from "../Checkbox";

const Product = ({
    className,
    item,
    value,
    onChange,
    released,
    withoutСheckbox,
    onFolderUpdate,
}) => {
    const [visible, setVisible] = useState(false);

    const handleClick = () => {
        onChange();
        setVisible(!visible);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Date inconnue';
        try {
            return new Date(dateString).toLocaleDateString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch (error) {
            return 'Date invalide';
        }
    };

    const getStatusColor = (status) => {
        const normalizedStatus = status?.toLowerCase();
        switch (normalizedStatus) {
            case 'complet':
            case 'complete':
            case 'validé':
            case 'valide':
                return '#edf8f2';
            case 'incomplet':
            case 'incomplete':
            case 'en attente':
            case 'pending':
                return '#fff7ed';
            case 'rejeté':
            case 'rejected':
            case 'refusé':
                return '#fef2f2';
            case 'en cours':
            case 'in_progress':
                return '#ecf9fe';
            default:
                return '#f0f4ff';
        }
    };

    const calculateProgress = () => {
        const totalSteps = 4;
        let completedSteps = 0;
        let progressData;
        let studentData;
        let schoolData;

        // Chercher les données de progression entreprise
        const potentialProgressPaths = [
            item?.progression?.entreprise,
        ];
        progressData = potentialProgressPaths.find(p => p);

        // Chercher les données de progression étudiant
        const potentialStudentPaths = [
            item?.progression?.etudiant,
        ];
        studentData = potentialStudentPaths.find(p => p);

        // Chercher les données de progression école
        const potentialSchoolPaths = [
            item?.progression?.ecole,
        ];
        schoolData = potentialSchoolPaths.find(p => p);

        if (typeof item?.progress === 'string') {
            try {
                const parsed = JSON.parse(item.progress);
                progressData = parsed?.entreprise || progressData;
                studentData = parsed?.etudiant || studentData;
                schoolData = parsed?.ecole || schoolData;
            } catch (e) {
                // Erreur de parsing, on ne fait rien
            }
        }

        if (typeof item?.progression === 'string') {
            try {
                const parsed = JSON.parse(item.progression);
                progressData = parsed?.entreprise || progressData;
                studentData = parsed?.etudiant || studentData;
                schoolData = parsed?.ecole || schoolData;
            } catch (e) {
                // Erreur de parsing, on ne fait rien
            }
        }

        // Si on n'a pas trouvé dans progress/progression, chercher directement dans item.progression
        if (!progressData && item?.progression?.entreprise) {
            progressData = item.progression.entreprise;
        }
        if (!studentData && item?.progression?.etudiant) {
            studentData = item.progression.etudiant;
        }
        if (!schoolData && item?.progression?.ecole) {
            schoolData = item.progression.ecole;
        }


        // Déterminer l'état du workflow
        const studentCompleted = studentData?.sign;
        const companyCompleted = progressData?.sign;
        const schoolCompleted = schoolData?.sign;
        
        // Vérifier si TOUS les sign sont à true
        const allCompleted = studentCompleted && companyCompleted && schoolCompleted;

        if (progressData) {
            // Étape 1: Informations remplies
            if (progressData.infos_remplies) {
                completedSteps++;
            }
            // Étape 2: Contrat créé
            if (progressData.contrat_cree) {
                completedSteps++;
            }
            // Étape 3: Tuteur assigné
            if (progressData.tuteur_assigne) {
                completedSteps++;
            }
            // Étape 4: Signé
            if (progressData.sign) {
                completedSteps++;
            }
        }

        const progressPercent = (completedSteps / totalSteps) * 100;

        return {
            completedSteps,
            totalSteps,
            progressPercent,
            progressWidth: `${progressPercent}%`,
            studentCompleted,
            companyCompleted,
            schoolCompleted,
            allCompleted
        };
    };

    const currentStatus = item.status || item.folder_status;
    const progress = calculateProgress();
    const isProgressComplete = progress.progressPercent === 100;
    const progressColor = isProgressComplete ? "#10B981" : "#78C4D1";

    return (
        <div
            className={cn(styles.product, className, {
                [styles.active]: visible,
            })}
        >
            <div className={styles.preview}>
                {!withoutСheckbox && (
                    <Checkbox
                        className={styles.checkbox}
                        classCheckboxTick={styles.checkboxTick}
                        value={value}
                        onChange={handleClick}
                    />
                )}
                <Control className={styles.control} item={item} onFolderUpdate={onFolderUpdate} />
                <div
                    className={styles.dashboardCard}
                    style={{ backgroundColor: getStatusColor(currentStatus) }}
                >
                    <div className={styles.cardIcon}>
                        <Icon name="info-stroke" size="24" />
                    </div>
                    <div className={styles.cardContent}>
                        <div className={styles.cardTitle}>
                        {item.expand?.student_id?.first_name ? `  ${item.expand.student_id.first_name} ${item.expand.student_id.last_name}` : 'Aucun étudiant'}
                        </div>
                        <div className={styles.cardStatus}>
                            N° : {item.id}
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.date}>
                <Icon name="clock" size="16" />
                Créé le {formatDate(item.created || item.creation_date || item.date)}
            </div>
            <div className={styles.progressContainer}>
                <div className={styles.progressBox}>
                    <div
                        className={styles.progressNumber}
                        style={{ color: progressColor }}
                    >
                        {progress.completedSteps}/{progress.totalSteps}
                    </div>
                    <div className={styles.progressLine}>
                        <div
                            className={styles.progressBar}
                            style={{
                                backgroundColor: progressColor,
                                width: progress.progressWidth,
                            }}
                        ></div>
                    </div>
                </div>
                <div className={cn(
                    styles.statusBadge,
                    'status-type',
                    progress.allCompleted ? 'status-green' : 'status-blue'
                )}>
                    {progress.allCompleted ? 'Terminé' : 'En cours de traitement'}
                </div>
            </div>
        </div>
    );
};

export default Product;